import React from 'react';

function EnableDisableButton(props){
  const {
    option,
    classname,
    handleClick,
    checkAttr1,
    checkAttr2,
    type,
  } = props;
  return (
    <div
      className={`option-btn option-btn--${classname}`}
      onClick={handleClick.bind(this, option.id)}
      disabled={(checkAttr1 !== null && checkAttr1 !== option.id)
                || (checkAttr2)}
    >
      <span>
        Enable/disable
        <br />
        {type}
      </span>
    </div>
  );
};

export default EnableDisableButton;
